const suppressAnalyticsOnUnloadKey = '__resistappSuppressAnalyticsOnUnload';

type AuthChangingNavigationGlobal = typeof globalThis & {
  [suppressAnalyticsOnUnloadKey]?: boolean;
};

function getAuthChangingNavigationGlobal(): AuthChangingNavigationGlobal {
  return globalThis as AuthChangingNavigationGlobal;
}

export function markAuthChangingNavigation(): void {
  getAuthChangingNavigationGlobal()[suppressAnalyticsOnUnloadKey] = true;
}

export function clearAuthChangingNavigation(): void {
  getAuthChangingNavigationGlobal()[suppressAnalyticsOnUnloadKey] = undefined;
}

export function shouldSuppressAnalyticsOnUnload(): boolean {
  return getAuthChangingNavigationGlobal()[suppressAnalyticsOnUnloadKey] === true;
}
